export default __webpack_public_path__ + "static/Inter-SemiBold-945e781bc80fb04da8ee38ce2b240082.woff";